import apiController from './api.controller';

export default angular
  .module('st.API', ['st.Core', 'angular-cache'])
  .controller('apiController', apiController)
  .constant('API', {});
